// AUTO-GENERATED by scripts/generate-tokens.mjs — DO NOT EDIT.
// Source of truth: src/theme/design-tokens.generated.json (key: sportColors)
//   <- beoflow-design-tokens-sync (Drafted "Beoflow Design System" / foundations/sportColors)
// Regenerate: npm run tokens:gen   (no-drift gate: npm run tokens:check)
//
// The .generated suffix means DO NOT HAND-EDIT. These are the Beoflow per-sport accent colors.
// Mirrors the iOS Beoflow/Theme/ files; values are web-idiomatic (hex/rgba, numeric weights, px).

export const sportColors = {
  hybrid: '#FFCE7A',
  aerobic: '#FFDFD4',
  running: '#FFAE94',
  biking: '#86BED4',
  skating: '#8FDBCE',
  swimming: '#3593B8',
  strength: '#BA688C',
  paddling: '#7FB3C8',
  other: '#F8F6F4',
} as const;
export type BeoflowSportName = keyof typeof sportColors;

/** Display name + backend id per sport (from iOS ActivityTypeConfig). */
export const sportColorMeta = {
  hybrid: { name: 'Hybrid', backendId: 2 },
  aerobic: { name: 'Aerobic', backendId: 3 },
  running: { name: 'Running', backendId: 4 },
  biking: { name: 'Biking', backendId: 5 },
  skating: { name: 'Skating', backendId: 6 },
  swimming: { name: 'Swimming', backendId: 7 },
  strength: { name: 'Strength', backendId: 8 },
  paddling: { name: 'Paddle Sport', backendId: 13 },
  other: { name: 'Other', backendId: 10 },
} as const;
